module.exports = __webpack_public_path__ + "img/gt.e45eb32d.svg";